import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faTruck,
  faChartLine,
  faRoute,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import './onboarding.css';

export default function OnboardingModal({ isOpen, onStart }) {
  if (!isOpen) return null;

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-modal">
        <div className="onboarding-header">
          <div className="onboarding-title">
            Fleet
          </div>
          <p className="onboarding-subtitle">
            Quelques étapes simples pour commencer à optimiser vos livraisons
          </p>
        </div>

        <div className="onboarding-content">
          <div className="onboarding-features">
            <div className="onboarding-feature">
              <div className="onboarding-feature-icon onboarding-icon-primary">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <div className="onboarding-feature-content">
                <h3>Tableau de bord</h3>
                <p>
                  Suivez en temps réel toutes vos livraisons et performances
                </p>
              </div>
            </div>

            <div className="onboarding-feature">
              <div className="onboarding-feature-icon onboarding-icon-success">
                <FontAwesomeIcon icon={faRoute} />
              </div>
              <div className="onboarding-feature-content">
                <h3>Affectation camions</h3>
                <p>
                  Optimisez automatiquement l'ordonnancement de vos tournées
                </p>
              </div>
            </div>
          </div>

          <div className="onboarding-divider">
            <span>Pour commencer, vous devez configurer :</span>
          </div>

          <div className="onboarding-steps">
            <div className="onboarding-step">
              <div className="onboarding-step-number">1</div>
              <div className="onboarding-step-icon">
                <FontAwesomeIcon icon={faWarehouse} />
              </div>
              <div className="onboarding-step-content">
                <h4>Les entrepôts</h4>
                <p>Plateformes de départ de vos camions</p>
              </div>
            </div>

            <div className="onboarding-step-arrow">
              <FontAwesomeIcon icon={faArrowRight} />
            </div>

            <div className="onboarding-step">
              <div className="onboarding-step-number">2</div>
              <div className="onboarding-step-icon">
                <FontAwesomeIcon icon={faTruck} />
              </div>
              <div className="onboarding-step-content">
                <h4>Les véhicules</h4>
                <p>Votre flotte de camions</p>
              </div>
            </div>
          </div>
        </div>

        <div className="onboarding-footer">
          <button className="onboarding-button" onClick={onStart}>
            Commencer la configuration
            <FontAwesomeIcon icon={faArrowRight} className="tw-ml-2" />
          </button>
          <p className="onboarding-help-text">
            Cette configuration ne prend que quelques minutes
          </p>
        </div>
      </div>
    </div>
  );
}

